/* ============ coffee.js — featured carousel + product (bean) detail ============ */
(function () {
  'use strict';
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }

  ready(function () {
    /* ---- Featured auto-rotating carousel (rewrite of the Framer Motion AnimatePresence) ---- */
    document.querySelectorAll('[data-cf]').forEach(function (cf) {
      var slides = cf.querySelectorAll('[data-cf-slide]');
      var dots = cf.querySelectorAll('[data-cf-dot]');
      if (slides.length === 0) return;
      var index = 0, timer;
      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
      }
      function start() { stop(); if (slides.length > 1) timer = setInterval(function () { show(index + 1); }, 5000); }
      function stop() { if (timer) clearInterval(timer); }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); start(); }); });
      cf.addEventListener('mouseenter', stop);
      cf.addEventListener('mouseleave', start);
      show(0); start();
    });

    /* ---- Bean / product detail: thumbnails, quantity, qty-aware add to cart, wishlist ---- */
    var detail = document.querySelector('[data-cb]');
    if (!detail) return;

    // thumbnail -> main image swap
    var main = detail.querySelector('[data-cb-main]');
    detail.querySelectorAll('[data-cb-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = thumb.getAttribute('data-img');
        if (main && url) main.style.backgroundImage = 'url(' + url + ')';
        detail.querySelectorAll('[data-cb-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // quantity stepper
    var qtyEl = detail.querySelector('[data-cb-qty]');
    var qty = 1;
    var unit = parseInt(detail.getAttribute('data-unit-price'), 10) || 0; // cents
    var priceEl = detail.querySelector('[data-cb-price]');
    function money(c) { return '$' + (c / 100).toFixed(2); }
    function renderQty() { if (qtyEl) qtyEl.textContent = qty; if (priceEl && unit) priceEl.textContent = money(unit * qty); }
    var dec = detail.querySelector('[data-cb-dec]');
    var inc = detail.querySelector('[data-cb-inc]');
    if (dec) dec.addEventListener('click', function () { if (qty > 1) { qty--; renderQty(); } });
    if (inc) inc.addEventListener('click', function () { qty++; renderQty(); });
    renderQty();

    // quantity-aware AJAX add to cart
    var addBtn = detail.querySelector('[data-cb-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var id = addBtn.getAttribute('data-variant-id');
        if (!id) return;
        var payloadItem = { id: id, quantity: qty };
        var w = addBtn.getAttribute('data-variant-weight');
        if (w) payloadItem.properties = { 'Weight': w };
        addBtn.style.opacity = '.6';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [payloadItem] })
        }).then(function (r) { return r.json(); }).then(function () {
          addBtn.style.opacity = '1';
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.style.display = c.item_count > 0 ? 'flex' : 'none'; });
          });
        }).catch(function () { addBtn.style.opacity = '1'; });
      });
    }

    // wishlist heart — visual toggle only (persistence requires a wishlist app)
    var heart = detail.querySelector('[data-cb-heart]');
    if (heart) heart.addEventListener('click', function () { heart.classList.toggle('is-active'); });
  });
})();